import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';
import { ActionTypes } from '../../utils/enums';

const TitleComponent = props => (
    <Title>
        <Span>{props.title}</Span>
    </Title>
);

TitleComponent.propTypes = {
    title: PropTypes.string
};

const VoteRegistrationUnsuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent title={props.title} />}
            hideSubtitle={true}
            {...props}
        />
    </TransitionContainerNoExit>
);

VoteRegistrationUnsuccess.propTypes = {
    title: PropTypes.string,
    thankYouText: PropTypes.string
};

export default connect(
    state => ({
        title:
            state.voteRegistration.successInfo.reason === 'underAge'
                ? 'Unfortunately, you must be 18 years or older in order to vote.'
                : !state.voteRegistration.completeVoteRegistration.message
                    ? 'Sorry, your state does not support online voter verification.'
                    : '',
        thankYouText:
            state.voteRegistration.successInfo.reason === 'underAge'
                ? 'You can still #TakeAction and make your voice heard by using Action Button. Visit <a href="http://actionbutton.org" target="_blank">actionbutton.org</a> to get started.'
                : state.voteRegistration.completeVoteRegistration.message || ''
    }),
    {},
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.VoteRegistration)
                return true;

            return next === prev;
        }
    }
)(VoteRegistrationUnsuccess);
